/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { forwardRef } from "react";
import type { ReactNode } from "react";

import { ResponsiveContainer } from "@components/elements/atoms/container/ResponsiveContainer.atom";
import { SectionContainer } from "@components/elements/atoms/container/SectionContainer.atom";

export type DirectorySectionProps = {
	children: ReactNode;
	disablePaddingBlockStart?: boolean;
	disablePaddingBlockEnd?: boolean;
};

/**
 * Canonical Directory section frame — `ResponsiveContainer + SectionContainer`
 * matching the rest of the Cosmos sections. Lift consumers off the primitive
 * atoms so the framing stays consistent if section spacing tokens are tuned
 * later.
 */
export const DirectorySection = forwardRef<HTMLElement, DirectorySectionProps>(
	({ children, disablePaddingBlockStart, disablePaddingBlockEnd }, ref) => (
		<ResponsiveContainer>
			<SectionContainer
				ref={ref}
				disablePaddingBlockStart={disablePaddingBlockStart}
				disablePaddingBlockEnd={disablePaddingBlockEnd}
			>
				{children}
			</SectionContainer>
		</ResponsiveContainer>
	),
);

DirectorySection.displayName = "DirectorySection";
